// extracted by mini-css-extract-plugin
export default {"image":"LabSKUHandler__image__wAKEJ","textCenter":"LabSKUHandler__textCenter__Gt74j","primaryButton":"LabSKUHandler__primaryButton__azjuo"};
    if(module.hot) {
      // 1753447559698
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  